export enum InfringementType {
    INTERRUPTION = 'INTERRUPTION',
    TIME_VIOLATION = 'TIME_VIOLATION',
    CODE_VIOLATION = 'CODE_VIOLATION',
    OVERRULE = 'OVERRULE'
}
